import React, { useContext, useEffect, useState } from "react";
// import "./SellerDashboard.css";
import SellerMasterLayout from "../../../layout/seller/SellerMasterLayout";
import "../../../assets/css/seller/DashboardInSeller.css";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
const DashboarInSeller = () => {
  const { baseUrl, loggedInSeller } = useContext(AppContext);
  const [ordersData, setOrdersData] = useState([]);
  const [dashboard, setDashboard] = useState({
    stats: {},
    recentOrders: [],
    supportTickets: [],
  });

  const [loading, setLoading] = useState(false);
  const [disputes, setDisputes] = useState([]);
  const navigate = useNavigate();
  const sellerId = loggedInSeller?.id;
  const statusClass = (status = "") => {
    switch (status.toLowerCase()) {
      case "ongoing":
        return "status-badge status-ongoing";

      case "completed":
        return "status-badge status-completed";

      case "cancelled":
        return "status-badge status-cancelled";

      case "pending":
        return "status-badge status-pending";

      case "open":
        return "status-badge status-open";

      case "resolved":
        return "status-badge status-resolved";

      default:
        return "status-badge";
    }
  };
  const viewOrders = () => {
    const sellerId = loggedInSeller?.id;
    if (!sellerId) return;

    const formData = new FormData();
    formData.append("tpshop_id", sellerId);
    console.log("Shop ID:", sellerId);

    axios
      .post(`${baseUrl}/seller/orders/viewOrders`, formData, {
        headers: { "Content-Type": "multipart/formData" },
      })
      .then((response) => {
        console.log("Orders:", response.data.orders);
        setOrdersData(response.data.orders);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const viewMyCustomerTickets = () => {
    if (!loggedInSeller?.id) return;

    const fd = new FormData();
    fd.append("tpshop_id", loggedInSeller.id);

    axios
      .post(`${baseUrl}/seller/general/viewMyCustomerTickets`, fd, {
        headers: { "Content-Type": "multipart/formData" },
      })
      .then((res) => {
        console.log(res.data.tickets[0]);
        console.log("Order ID:", res.data.tickets[0].order_id);
        console.log("Customer ID:", res.data.tickets[0].tpcustomer_id);
        console.log("Shop ID:", res.data.tickets[0].tpshop_id);
        setDisputes(res.data.tickets);
      })
      .catch((err) => console.log(err));
  };

  const fetchDashboard = () => {
    if (!loggedInSeller?.id) return;

    const formData = new FormData();
    formData.append("tpshop_id", loggedInSeller.id);

    axios
      .post(`${baseUrl}/seller/dashboard`, formData)
      .then((res) => {
        console.log("Dashboard API:", res.data);

        if (res.data.success) {
          setDashboard(res.data);
        }
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  useEffect(() => {
    viewOrders();
    viewMyCustomerTickets();
    fetchDashboard();
  }, [loggedInSeller]);
  const statCards = [
    {
      label: "Total Customers",
      value: dashboard.stats.totalCustomers || 0,
      change: "",
      icon: "👥",
      bg: "#7c3aed",
    },
    {
      label: "Total Deals",
      value: dashboard.stats.totalDeals || 0,
      change: "",
      icon: "⚡",
      bg: "#ebe7e4",
    },
    {
      label: "Total Orders",
      value: dashboard.stats.totalOrders || 0,
      change: "",
      icon: "🛍️",
      bg: "#4f46e5",
    },
    {
      label: "Revenue",
      value: dashboard.stats.totalRevenue || 0,
      change: "",
      icon: "💰",
      bg: "#22c55e",
    },
  ];

  return (
    <SellerMasterLayout>
      <div className="dashboard-page">
        <div className="dashboard-header">
          <h1>Dashboard</h1>
          <p>Welcome back! Here's an overview of your store.</p>
        </div>

        {/* Stat Cards */}
        <div className="stat-cards-grid">
          {statCards.map((card, idx) => (
            <div className="stat-card" key={idx}>
              <div className="stat-card-top">
                <span className="stat-label">{card.label}</span>
                <div className="stat-icon" style={{ backgroundColor: card.bg }}>
                  {card.icon}
                </div>
              </div>
              <div className="stat-value">{card.value}</div>
              <div className="stat-change">{card.change}</div>
            </div>
          ))}
        </div>

        {/* Recent Orders */}
        <div className="card recent-orders-card">
          <div className="card-header">
            <h2>Recent Orders</h2>

            <button
              className="view-all-link"
              onClick={() => navigate("/seller-orders")}
            >
              View all →
            </button>
          </div>
          <div className="table-wrapper">
            <table className="orders-table">
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Customer</th>
                  <th>Deal</th>
                  <th>Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {ordersData.map((order) => (
                  <tr key={order.id}>
                    <td className="order-id">{order.id}</td>

                    <td>{order.tpcustomer?.fullname}</td>

                    <td>
                      {" "}
                      {order.tpcarts?.map((cart) => (
                        <span key={cart.id} className="tfp-deal-tag">
                          {cart.tpdeal?.deal_title}
                        </span>
                      ))}
                    </td>

                    <td>{order.amount}</td>

                    <td>
                      <span className={statusClass(order.status)}>
                        {order.status}
                      </span>
                    </td>
                  </tr>
                ))}{" "}
              </tbody>
            </table>
          </div>
        </div>

        {/* Bottom Grid */}
        <div className="bottom-grid">
          {/* Support Tickets */}
          <div className="card">
            <div className="card-header">
              <h2>
                <span className="header-icon">⊘</span> Recent Support Tickets
              </h2>

              <button
                className="view-all-link"
                onClick={() => navigate("/seller-supports")}
              >
                View all →
              </button>
            </div>
            <div className="table-wrapper">
              <table className="orders-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Title</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>

                <tbody>
                  {disputes.length > 0 ? (
                    disputes.map((ticket) => (
                      <tr key={ticket.id}>
                        <td>{ticket.id}</td>

                        <td>{ticket.title}</td>

                        <td>{ticket.description}</td>

                        <td>
                          <span className={statusClass(ticket.status)}>
                            {ticket.status}
                          </span>
                        </td>

                        <td>{ticket.created_at}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="5"
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        No Support Tickets Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </SellerMasterLayout>
  );
};

export default DashboarInSeller;
